var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.content.length)?_c('div',_vm._l((_vm.content),function(contentItem){return _c('storyblok-resolver',{key:contentItem._uid,attrs:{"block":contentItem}})}),1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }